<template>
  <div class="downgrade__container d-flex flex-column align-items-center">
    <div class="downgrade__header d-flex align-items-center justify-content-between">
      <div class="downgrade__header-left d-flex">
        <div class="downgrade__header-left__back-action-btn d-flex align-items-center mr-3 clickable" @click="exitDowngrade">
          <div class="downgrade__header-back-icon-wrapper d-flex mr-1"><i class="icon icon-arrow-left text-dark6"></i></div>
          <p>{{$tc('downgrade.backToPricing')}}</p>
        </div>
        <GpTabs class="downgrade__tabs-container" @tabChange="onTabChangeHandler" :customNav="true" :active.sync="filter">
          <template #GpTabsNav="{activeIndex, handler}">
            <GpTabsNav class="downgrade__tabs-nav">
              <GpTab
                class="downgrade__tab"
                :class="{ 'ml-1 ml-md-3': ind != 0 }"
                :index="t.key"
                :activeIndex="activeIndex || 'review'"
                :disabled="t.key == 'confirm' && disabledConfirm"
                @click="handler"
                v-for="(t, ind) in tabs" :key="'tab_' + t.key">
                <p class="typo-button14 typo-medium nowrap">{{ t.text }}</p>
              </GpTab>
            </GpTabsNav>
          </template>
        </GpTabs>
      </div>
      <div class="downgrade__header-cancel btn-icon btn-icon-lg d-flex clickable mr-2" @click="exitDowngrade">
        <i class="icon icon-cancel text-light-high"></i>
      </div>
    </div>
    <UnpublishModal v-if="isOpenUnpublishModal"/>
    <div class="downgrade__body">
      <ReviewPlan v-if="filter == 'review'" @backToViewPlan="exitDowngrade" @goToConfirmation="goToConfirmation"/>
      <Confirmation v-else-if="filter == 'confirm'"/>
    </div>
  </div>
</template>

<script>
import GpTabs, { GpTab, GpTabsNav } from "@/core/shared/GpTabs";
import ReviewPlan from "./ReviewPlan.vue";
import Confirmation from "./Confirmation.vue";
import UnpublishModal from "../components/UnpublishModal/UnpublishModal";
import {mapState, mapMutations} from "vuex";
import { mutations} from "@/store/downgrade/types";

export default {
  name: 'Downgrade',
  components: {
    GpTabs,
    GpTab,
    GpTabsNav,
    ReviewPlan,
    Confirmation,
    UnpublishModal
  },
  data() {
    return {
      prevRoute: null,
      filter: 'review',
    }
  },
  computed: {
    ...mapState("downgrade", {
      disabledConfirm: state => state.disabledConfirm,
      isOpenUnpublishModal: state => state.isOpenUnpublishModal,
    }),
    tabs() {
      return [
        {
          text: this.$tc('downgrade.tab.reviewPlan'),
          key: 'review'
        },
        {
          text: this.$tc('downgrade.tab.confirmation'),
          key: 'confirm'
        },
      ];
    },
  },
  created () {
    this.setChoosedPlan(this.$route.params.plan);
  },
  methods: {
    ...mapMutations("downgrade", {
      setChoosedPlan: mutations.SET_CHOOSED_PLAN,
      resetData: mutations.RESET_DATA
    }),
    onTabChangeHandler(tab) {
      this.filter = tab;
    },
    exitDowngrade() {
      this.resetData();
      if (this.prevRoute.name != null) this.$router.go(-1);
      else this.$router.push({ name: "Pricing" });
    },
    goToConfirmation() {
      this.filter = 'confirm';
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
}
</script>

<style lang="scss">
  .downgrade {
    &__header {
      &-left {
        height: 100%;
        margin-left: 120px;
      }
      &-back-icon-wrapper {
        height: 16px;
        width: 16px;
        @include flex-center;
      }
      &-left__back-action-btn {
        color: $dark6;
        font-weight: 500;
        line-height: 16px;
        &:hover {
          color: $textLightModeHigh;
          .icon {
            color: $textLightModeHigh;
          }
        }
      }
      width: 100%;
      height: 60px;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        border-bottom: solid 1px rgba(73, 73, 73, 0.1);
        position: absolute;
        bottom: 0;
        z-index: -3;
      }
    }
    &__body {
      height: 100%;
      width: 100%;
      padding-left: 120px;
    }
    &__container {
      background-color: white;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-attachment: local;
      display: flex;
      z-index: 50;
    }
  }
</style>
